/** API origin and authenticated media paths. Media consumers fetch bytes with
 * bearer authentication through privateMedia; these URLs never contain tokens. */
const trimSlash = (url: string) => url.replace(/\/+$/, "");
export const MME_API_URL = trimSlash(
  import.meta.env.VITE_MME_API_URL || "http://localhost:15000",
);
export type PhotoSize = 450 | 900;
export const photoUrl = (
  photoUuid: string | null | undefined,
  size: PhotoSize = 450,
  forMemberId?: number,
): string | undefined =>
  photoUuid
    ? `${MME_API_URL}/staff/media/${encodeURIComponent(photoUuid)}?size=${size}${forMemberId ? `&for_member_id=${forMemberId}` : ""}`
    : undefined;
export const audioUrl = (audioUuid: string): string =>
  `${MME_API_URL}/staff/audio/${encodeURIComponent(audioUuid)}`;
